export default class PageHelper {
    static IMAGE_BLOG_URL_PATTERN = "https://firebasestorage.googleapis.com/v0/b/mybajaphoto-284cd.firebasestorage.app/o/<event-id>%2F<folder>%2F<image-name>?alt=media";

    static getImageSourceUrl(eventId: string,
                             folder: string, 
                             imageName: string): string {
        const eventToken = "<event-id>";
        const folderToken = "<folder>";
        const imageToken = "<image-name>";

        return this.IMAGE_BLOG_URL_PATTERN.replace(eventToken, eventId)
            .replace(folderToken, folder)
            .replace(imageToken, imageName);
    }

}